<template>
  <div class="bg">
    <div class="content">
      <img
        class="success"
        src="@/assets/images/success.png"
        alt="成功"
      />
      <p>电核中...</p>
      <p>
        支用申请前需要电核，核实申请人信息，请联系您的客户经理处理。
      </p>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ServerBank from '@/components/ServerBank.vue';

export default {
  name: 'nuclearElectricity',
  components: {
    ServerBank,
  },
  data() {
    return {
      num: 0,
    };
  },
  mounted() {
    this.jumpCurrPage();
    setInterval(() => {
      this.jumpCurrPage();
    }, 5000);
  },
  methods: {
    // 后端进行跳转
    jumpCurrPage() {
      const { orderId } = this.commonForms;
      this.$api.PublicPage.jumpCurrPage({
        orderId: orderId || localStorage.getItem('orderId'),
      })
        .then((res) => {
          if (res.success) {
            if (res.data) {
              if (res.data === '/supermarket/v2/nuclearElectricity') return;
              window.location.href = res.data;
            }
          }
        });
    },
  },
  computed: {
    ...mapState({
      commonForms(val) {
        return val.commonForms;
      },
    }),
  },

};
</script>
<style scoped>
/* 提款审批中 */
.bg {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 60px;
  color: #a6a6a6;
  box-sizing: border-box;
}

.content .success {
  width: 60px;
  height: 60px;
}

.content p:nth-child(2) {
  font-size: 16px;
  font-weight: bold;
  margin: 30px 0;
}

.content p:nth-child(3) {
  font-size: 14px;
  text-align: left;
}
</style>
